<template>
  <div class="w-screen h-screen grid grid-rows-content-status grid-cols-nav-content">
    <main-nav-bar class="row-span-2" />
    <div class="overflow-hidden">
      <slot />
    </div>
    <status-bar />
  </div>
</template>

<script lang="ts" setup>
import MainNavBar from '@/shared/components/MainNavBar.vue'
import StatusBar from '@/shared/components/StatusBar.vue'
</script>
